module.exports = __webpack_public_path__ + "img/shouye-zizhi-png.1072b45e.svg";